import { render, staticRenderFns } from "./HomeFornitori.vue?vue&type=template&id=f7b4d79e&scoped=true"
import script from "./HomeFornitori.vue?vue&type=script&lang=js"
export * from "./HomeFornitori.vue?vue&type=script&lang=js"
import style0 from "./HomeFornitori.vue?vue&type=style&index=0&id=f7b4d79e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7b4d79e",
  null
  
)

export default component.exports